var map = {
	"./0000.png": 61768,
	"./0001.png": 98287,
	"./0002.png": 39502,
	"./0003.png": 88333,
	"./0004.png": 78508,
	"./0005.png": 38739,
	"./0006.png": 88962,
	"./0007.png": 94737,
	"./0008.png": 69600,
	"./0009.png": 74407,
	"./0010.png": 23549,
	"./0011.png": 66526,
	"./0012.png": 4671,
	"./0013.png": 40536,
	"./0014.png": 87713,
	"./ai_b.png": 77991,
	"./ai_w.png": 66708,
	"./avatar_none.png": 65424,
	"./avatar_tsumego_ai_1-kid.png": 22844,
	"./avatar_tsumego_ai_1.png": 81825,
	"./avatar_tsumego_ai_10-kid.png": 49186,
	"./avatar_tsumego_ai_10.png": 4539,
	"./avatar_tsumego_ai_100.png": 85017,
	"./avatar_tsumego_ai_101.png": 34762,
	"./avatar_tsumego_ai_102.png": 83195,
	"./avatar_tsumego_ai_103.png": 29684,
	"./avatar_tsumego_ai_104.png": 21685,
	"./avatar_tsumego_ai_105.png": 73238,
	"./avatar_tsumego_ai_106.png": 12791,
	"./avatar_tsumego_ai_107.png": 80944,
	"./avatar_tsumego_ai_108.png": 50049,
	"./avatar_tsumego_ai_109.png": 50706,
	"./avatar_tsumego_ai_11-kid.png": 83449,
	"./avatar_tsumego_ai_11.png": 53172,
	"./avatar_tsumego_ai_110.png": 62340,
	"./avatar_tsumego_ai_111.png": 60363,
	"./avatar_tsumego_ai_112.png": 71802,
	"./avatar_tsumego_ai_113.png": 73193,
	"./avatar_tsumego_ai_114.png": 77568,
	"./avatar_tsumego_ai_115.png": 74055,
	"./avatar_tsumego_ai_116.png": 1222,
	"./avatar_tsumego_ai_117.png": 21381,
	"./avatar_tsumego_ai_118.png": 48140,
	"./avatar_tsumego_ai_119.png": 67347,
	"./avatar_tsumego_ai_12-kid.png": 26564,
	"./avatar_tsumego_ai_12.png": 52761,
	"./avatar_tsumego_ai_120.png": 27459,
	"./avatar_tsumego_ai_121.png": 53372,
	"./avatar_tsumego_ai_122.png": 23777,
	"./avatar_tsumego_ai_123.png": 79506,
	"./avatar_tsumego_ai_124.png": 40735,
	"./avatar_tsumego_ai_125.png": 76600,
	"./avatar_tsumego_ai_126.png": 59613,
	"./avatar_tsumego_ai_127.png": 2590,
	"./avatar_tsumego_ai_128.png": 77051,
	"./avatar_tsumego_ai_129.png": 25684,
	"./avatar_tsumego_ai_13-kid.png": 9947,
	"./avatar_tsumego_ai_13.png": 65322,
	"./avatar_tsumego_ai_130.png": 33990,
	"./avatar_tsumego_ai_131.png": 97893,
	"./avatar_tsumego_ai_132.png": 89312,
	"./avatar_tsumego_ai_133.png": 94119,
	"./avatar_tsumego_ai_134.png": 48986,
	"./avatar_tsumego_ai_135.png": 28137,
	"./avatar_tsumego_ai_136.png": 53252,
	"./avatar_tsumego_ai_137.png": 2507,
	"./avatar_tsumego_ai_138.png": 59214,
	"./avatar_tsumego_ai_139.png": 8045,
	"./avatar_tsumego_ai_14-kid.png": 70494,
	"./avatar_tsumego_ai_14.png": 76343,
	"./avatar_tsumego_ai_140.png": 73629,
	"./avatar_tsumego_ai_141.png": 72926,
	"./avatar_tsumego_ai_15-kid.png": 11525,
	"./avatar_tsumego_ai_15.png": 31344,
	"./avatar_tsumego_ai_16-kid.png": 92464,
	"./avatar_tsumego_ai_16.png": 38421,
	"./avatar_tsumego_ai_17-kid.png": 76503,
	"./avatar_tsumego_ai_17.png": 1110,
	"./avatar_tsumego_ai_18-kid.png": 36154,
	"./avatar_tsumego_ai_18.png": 38595,
	"./avatar_tsumego_ai_19-kid.png": 34993,
	"./avatar_tsumego_ai_19.png": 80860,
	"./avatar_tsumego_ai_2-kid.png": 55825,
	"./avatar_tsumego_ai_2.png": 91804,
	"./avatar_tsumego_ai_20-kid.png": 99761,
	"./avatar_tsumego_ai_20.png": 91548,
	"./avatar_tsumego_ai_21-kid.png": 59578,
	"./avatar_tsumego_ai_21.png": 12035,
	"./avatar_tsumego_ai_22-kid.png": 54259,
	"./avatar_tsumego_ai_22.png": 94002,
	"./avatar_tsumego_ai_23-kid.png": 95868,
	"./avatar_tsumego_ai_23.png": 23873,
	"./avatar_tsumego_ai_24-kid.png": 42045,
	"./avatar_tsumego_ai_24.png": 88600,
	"./avatar_tsumego_ai_25-kid.png": 24342,
	"./avatar_tsumego_ai_25.png": 62559,
	"./avatar_tsumego_ai_26-kid.png": 86063,
	"./avatar_tsumego_ai_26.png": 93694,
	"./avatar_tsumego_ai_27-kid.png": 63848,
	"./avatar_tsumego_ai_27.png": 91389,
	"./avatar_tsumego_ai_28-kid.png": 68793,
	"./avatar_tsumego_ai_28.png": 16884,
	"./avatar_tsumego_ai_29-kid.png": 69250,
	"./avatar_tsumego_ai_29.png": 45979,
	"./avatar_tsumego_ai_3-kid.png": 95770,
	"./avatar_tsumego_ai_3.png": 33187,
	"./avatar_tsumego_ai_30-kid.png": 4044,
	"./avatar_tsumego_ai_30.png": 23601,
	"./avatar_tsumego_ai_31-kid.png": 47331,
	"./avatar_tsumego_ai_31.png": 3106,
	"./avatar_tsumego_ai_32-kid.png": 90666,
	"./avatar_tsumego_ai_32.png": 61043,
	"./avatar_tsumego_ai_33-kid.png": 15329,
	"./avatar_tsumego_ai_33.png": 25484,
	"./avatar_tsumego_ai_34-kid.png": 22808,
	"./avatar_tsumego_ai_34.png": 83213,
	"./avatar_tsumego_ai_35-kid.png": 9375,
	"./avatar_tsumego_ai_35.png": 12654,
	"./avatar_tsumego_ai_36-kid.png": 50566,
	"./avatar_tsumego_ai_36.png": 93263,
	"./avatar_tsumego_ai_37-kid.png": 88749,
	"./avatar_tsumego_ai_37.png": 48072,
	"./avatar_tsumego_ai_38-kid.png": 16436,
	"./avatar_tsumego_ai_38.png": 50537,
	"./avatar_tsumego_ai_39-kid.png": 83371,
	"./avatar_tsumego_ai_39.png": 65498,
	"./avatar_tsumego_ai_4-kid.png": 95791,
	"./avatar_tsumego_ai_4.png": 95582,
	"./avatar_tsumego_ai_40-kid.png": 8675,
	"./avatar_tsumego_ai_40.png": 29410,
	"./avatar_tsumego_ai_41-kid.png": 36524,
	"./avatar_tsumego_ai_41.png": 81585,
	"./avatar_tsumego_ai_42-kid.png": 39841,
	"./avatar_tsumego_ai_42.png": 5772,
	"./avatar_tsumego_ai_43-kid.png": 97162,
	"./avatar_tsumego_ai_43.png": 31059,
	"./avatar_tsumego_ai_44-kid.png": 69567,
	"./avatar_tsumego_ai_44.png": 38574,
	"./avatar_tsumego_ai_45-kid.png": 45016,
	"./avatar_tsumego_ai_45.png": 6029,
	"./avatar_tsumego_ai_46-kid.png": 21677,
	"./avatar_tsumego_ai_46.png": 57416,
	"./avatar_tsumego_ai_47-kid.png": 1286,
	"./avatar_tsumego_ai_47.png": 89935,
	"./avatar_tsumego_ai_48-kid.png": 72299,
	"./avatar_tsumego_ai_48.png": 41114,
	"./avatar_tsumego_ai_49-kid.png": 308,
	"./avatar_tsumego_ai_49.png": 95497,
	"./avatar_tsumego_ai_5-kid.png": 65384,
	"./avatar_tsumego_ai_5.png": 39357,
	"./avatar_tsumego_ai_50-kid.png": 60694,
	"./avatar_tsumego_ai_50.png": 12639,
	"./avatar_tsumego_ai_51.png": 38680,
	"./avatar_tsumego_ai_52.png": 25117,
	"./avatar_tsumego_ai_53.png": 27422,
	"./avatar_tsumego_ai_54.png": 45763,
	"./avatar_tsumego_ai_55.png": 2895,
	"./avatar_tsumego_ai_56.png": 73953,
	"./avatar_tsumego_ai_57.png": 44082,
	"./avatar_tsumego_ai_58.png": 20759,
	"./avatar_tsumego_ai_59.png": 33936,
	"./avatar_tsumego_ai_6-kid.png": 82717,
	"./avatar_tsumego_ai_6.png": 69720,
	"./avatar_tsumego_ai_60.png": 2400,
	"./avatar_tsumego_ai_61.png": 74215,
	"./avatar_tsumego_ai_62.png": 14246,
	"./avatar_tsumego_ai_63.png": 41637,
	"./avatar_tsumego_ai_64.png": 65668,
	"./avatar_tsumego_ai_65.png": 69419,
	"./avatar_tsumego_ai_66.png": 858,
	"./avatar_tsumego_ai_67.png": 28873,
	"./avatar_tsumego_ai_68.png": 99464,
	"./avatar_tsumego_ai_69.png": 49039,
	"./avatar_tsumego_ai_7-kid.png": 47222,
	"./avatar_tsumego_ai_7.png": 11231,
	"./avatar_tsumego_ai_70.png": 94197,
	"./avatar_tsumego_ai_71.png": 69046,
	"./avatar_tsumego_ai_72.png": 74071,
	"./avatar_tsumego_ai_73.png": 59920,
	"./avatar_tsumego_ai_74.png": 83673,
	"./avatar_tsumego_ai_75.png": 53770,
	"./avatar_tsumego_ai_76.png": 18331,
	"./avatar_tsumego_ai_77.png": 45492,
	"./avatar_tsumego_ai_78.png": 84765,
	"./avatar_tsumego_ai_79.png": 84062,
	"./avatar_tsumego_ai_8-kid.png": 58011,
	"./avatar_tsumego_ai_8.png": 66538,
	"./avatar_tsumego_ai_80.png": 44838,
	"./avatar_tsumego_ai_81.png": 64997,
	"./avatar_tsumego_ai_82.png": 21184,
	"./avatar_tsumego_ai_83.png": 17671,
	"./avatar_tsumego_ai_84.png": 15418,
	"./avatar_tsumego_ai_85.png": 16809,
	"./avatar_tsumego_ai_86.png": 5956,
	"./avatar_tsumego_ai_87.png": 20331,
	"./avatar_tsumego_ai_88.png": 62574,
	"./avatar_tsumego_ai_89.png": 33133,
	"./avatar_tsumego_ai_9-kid.png": 30436,
	"./avatar_tsumego_ai_9.png": 16793,
	"./avatar_tsumego_ai_90.png": 45027,
	"./avatar_tsumego_ai_91.png": 3644,
	"./avatar_tsumego_ai_92.png": 93665,
	"./avatar_tsumego_ai_93.png": 10674,
	"./avatar_tsumego_ai_94.png": 23071,
	"./avatar_tsumego_ai_95.png": 81560,
	"./avatar_tsumego_ai_96.png": 51197,
	"./avatar_tsumego_ai_97.png": 23774,
	"./avatar_tsumego_ai_98.png": 26811,
	"./avatar_tsumego_ai_99.png": 73300,
	"./ladder_b.png": 78741,
	"./ladder_w.png": 11418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38727;